import { apiGetList } from './ApiBaseActions';
export const API_GET_LIST_PROFESSIONAL_RFP_PROPOSAL = 'API_GET_LIST_PROFESSIONAL_RFP_PROPOSAL';
export const API_GET_LIST_PROFESSIONAL_RFP_UNREAD = 'API_GET_LIST_PROFESSIONAL_RFP_UNREAD';
export const API_GET_LIST_PROFESSIONAL_RFP_OFFERED = 'API_GET_LIST_PROFESSIONAL_RFP_OFFERED';
/**
 * 閲覧申請済の案件一覧の取得
 * @param request
 * @param meta
 */
export const apiGetListProfessionalRfpProposal = (request, meta) => apiGetList(API_GET_LIST_PROFESSIONAL_RFP_PROPOSAL, '/professional/rfp_proposal', {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
/**
 * 未読の案件一覧の取得
 * @param request
 * @param meta
 */
export const apiGetListProfessionalRfpUnRead = (request, meta) => apiGetList(API_GET_LIST_PROFESSIONAL_RFP_UNREAD, '/professional/rfp_unread', {}, Object.assign(Object.assign({}, meta), { ignoreTransform: true, isSnakeCase: true }));
/**
 * 提案済みの案件一覧の取得
 * @param request
 * @param meta
 */
export const apiGetListProfessionalRfpOffered = ({ query: { page } }, meta) => apiGetList(API_GET_LIST_PROFESSIONAL_RFP_OFFERED, '/professional/rfp_offered', { page }, Object.assign(Object.assign({}, meta), { ignoreTransform: true, isSnakeCase: true }));
